import * as React from "react";
import { style } from "typestyle";
import { FunctionComponent } from "react";

interface ILinkProps {
  href: string;
  children: JSX.Element;
}

const Link: FunctionComponent<ILinkProps> = ({
  href,
  children,
}: ILinkProps) => (
  <a
    className={style({
      cursor: "pointer",
      textDecoration: "none",
      $nest: {
        "&>*": {
          cursor: "pointer",
          textDecoration: "none",
        },
      },
    })}
    href={href}
    target={"_blank"}
    rel="noreferrer"
  >
    {children}
  </a>
);

export default Link;
